import { useLayoutEffect } from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'

const PINTEREST_SCRIPT_ID = 'pinterest-tag-script'

export const useInitPinterestTag = (): void => {
  const { pinterestTagId } = useZustandStore(
    useShallow((state) => ({
      pinterestTagId: state.lead?.config?.cohort?.pinterestTagId,
    })),
  )

  useLayoutEffect(() => {
    if (!pinterestTagId) return

    if (document.getElementById(PINTEREST_SCRIPT_ID) || window.pintrk) {
      return
    }

    const script = document.createElement('script')
    script.id = PINTEREST_SCRIPT_ID
    script.type = 'text/javascript'
    script.text = `
      !function(e) {
        if(!window.pintrk) {
          window.pintrk=function() {
            window.pintrk.queue.push(Array.prototype.slice.call(arguments))
          };
          var n=window.pintrk;n.queue=[],n.version="3.0";
          var t=document.createElement("script");t.async=!0,t.src=e;
          var r=document.getElementsByTagName("script")[0];
              r.parentNode.insertBefore(t,r)
        }
      }
      ("https://s.pinimg.com/ct/core.js");
      pintrk('load', ${pinterestTagId}, {em: ''});
      pintrk('page');
      `
    document.head.appendChild(script)
  }, [pinterestTagId])
}
